import { Type, Smile, PenTool, Sticker, Sparkles, Trash2, Crop, Scissors } from 'lucide-react';

const TOOLS = [
  { id: 'text', label: 'Text', icon: Type },
  { id: 'emoji', label: 'Emoji', icon: Smile },
  { id: 'draw', label: 'Draw', icon: PenTool },
  { id: 'stickers', label: 'Stickers', icon: Sticker },
  { id: 'filters', label: 'Filters', icon: Sparkles },
  { id: 'crop', label: 'Crop', icon: Crop },
];

const VIDEO_TOOLS = [
  { id: 'trim', label: 'Trim', icon: Scissors },
];

export default function EditorToolbar({ activeTool, setActiveTool, hasSelection, onDelete, mediaType }) {
  const allTools = mediaType === 'video' ? [...TOOLS, ...VIDEO_TOOLS] : TOOLS;

  return (
    <div className="bg-card border-t border-border px-2 py-2 safe-bottom" data-testid="editor-toolbar">
      <div className="flex items-center justify-around overflow-x-auto">
        {allTools.map(tool => (
          <button
            key={tool.id}
            onClick={() => setActiveTool(activeTool === tool.id ? null : tool.id)}
            className={`flex flex-col items-center gap-0.5 px-2.5 py-1.5 rounded-lg transition-all flex-shrink-0 ${
              activeTool === tool.id ? 'text-violet-400 bg-violet-500/10' : 'text-muted-foreground/80 hover:text-foreground'
            }`}
            data-testid={`tool-${tool.id}`}
          >
            <tool.icon className="w-5 h-5" />
            <span className="text-[10px]">{tool.label}</span>
          </button>
        ))}
        {hasSelection && (
          <button onClick={onDelete}
            className="flex flex-col items-center gap-0.5 px-2.5 py-1.5 rounded-lg text-red-400 hover:text-red-300 flex-shrink-0"
            data-testid="tool-delete">
            <Trash2 className="w-5 h-5" />
            <span className="text-[10px]">Delete</span>
          </button>
        )}
      </div>
    </div>
  );
}
